export default [
  {
    path: "/organizationSetting",
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/organization/organizationManage/index"
      ),
    name: "organizationSetting",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["作业方管理"],
      permissionsPath: "/organizationSetting"
    }
  },

  {
    path: "/organizationDetail",
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/organization/organizationManage/detail"
      ),
    name: "organizationDetail",
    meta: {
      isTab: false,
      keepAlive: false,
      links: ["作业方详情"],
      permissionsPath: "/organizationSetting"
    }
  },
  {
    path: "/organizationHome",
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/organization/organizationHome/index"
      ),
    name: "organizationHome",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["作业方首页"],
      permissionsPath: "/organizationHome"
    }
  }
];
